@use "../../../styles/colors";

$form-hint-background-color-variable-name: --ixf-form-hint-background;

.formHint {
  // Default size: small
  --ixf-form-hint-padding: var(--ixf-space-2) var(--ixf-space-4);
  --ixf-form-hint-border-radius: 0;

  // Default variant: info
  #{$form-hint-background-color-variable-name}: var(--ixf-color-neutral-xlt);
  --ixf-form-hint-font-color: var(--ixf-text-tone-md);

  color: var(--ixf-form-hint-font-color);
  padding: var(--ixf-form-hint-padding);
  border-radius: var(--ixf-form-hint-border-radius);
  position: relative;
  background: var(--ixf-color-background);

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    background: var(#{$form-hint-background-color-variable-name});
  }

  > * {
    position: relative;
    z-index: 1;
  }

  &.hasPrefix {
    --ixf-form-hint-padding: var(--ixf-space-2) var(--ixf-space-4)
      var(--ixf-space-2) var(--ixf-space-3);
  }

  &.variant {
    &-error {
      --ixf-form-hint-font-color: var(--ixf-color-danger-dk);

      @include colors.define-best-supported-color-value(
        $form-hint-background-color-variable-name,
        color(from var(--ixf-color-danger-md) srgb r g b / 0.2),
        color(from var(--ixf-color-danger-md) display-p3 r g b / 0.2)
      );
    }

    &-important {
      #{$form-hint-background-color-variable-name}: var(--ixf-text-tone-md);
      --ixf-form-hint-font-color: var(--ixf-color-background);
    }

    &-primary {
      --ixf-form-hint-font-color: var(--ixf-color-primary-dk);

      @include colors.define-best-supported-color-value(
        $form-hint-background-color-variable-name,
        color(from var(--ixf-color-primary-md) srgb r g b / 0.2),
        color(from var(--ixf-color-primary-md) display-p3 r g b / 0.2)
      );
    }
  }

  &.withBorderRadius {
    --ixf-form-hint-border-radius: var(--ixf-border-radius-2);
  }
}
